<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <drdp-title [title]="t('activityBank.title')"></drdp-title>

  <drdp-container>
    <div class="w-full">
      <drdp-search
        (search)="search($event)"
        (clear)="onClear()"
        [searchInput]="searchInput"
        [textInputPlaceholder]="t('activityBank.searchPlaceholder')"
      ></drdp-search>
    </div>
  </drdp-container>

  <div class="input-rating-sheet">
    @for (domain of searchResults; track domain) {
    <div>
      <drdp-container additionClasses="min-h-[15rem] mt-4">
        <div class="md:flex place-content-between place-items-center self-center">
          <div class="font-semibold text-xl flex items-center gap-2">
            <img
              class="h-8 w-8"
              src="assets/images/domains/{{ domain.iconName }}"
              [alt]="domain.domainName"
            />
            <!-- Server-supplied domain name: localized by the API, not by Transloco. -->
            {{ domain.domainName }}
          </div>
          <drdp-btn (click)="openAddModal(domain)">{{ t('activityBank.addActivity') }}</drdp-btn>
        </div>

        <div class="mt-4 overflow-x-auto">
          <table
            class="table-auto min-w-full border-separate"
            [attr.aria-label]="t('activityBank.tableAriaLabel')"
          >
            <thead>
              <tr>
                <th class="border border-gray-200 font-medium text-xs px-4 py-3 w-32">
                  {{ t('activityBank.measureColumn') }}
                </th>
                @for (level of domain.levels; track level) {
                <th class="border border-gray-200 font-medium text-xs px-4 py-3 min-w-80">
                  <!-- Server-supplied developmental level name. -->
                  {{ level }}
                </th>
                }
              </tr>
            </thead>
            <tbody class="bg-white">
              @for (measure of domain.measures; track measure.measureName) {
              <tr>
                <td class="p-3 border border-gray-200 align-top">
                  <!-- Server-supplied measure name. -->
                  <p class="font-bold text-xs">{{ measure.measureName }}</p>
                </td>
                @for (level of domain.levels; track level) {
                <td class="p-3 border border-gray-200 text-xs align-top">
                  @if (measure.levelActivities[level]?.length) {
                  <ul class="space-y-3 pt-2">
                    @for (activity of measure.levelActivities[level]; track activity.activityBankId) {
                    <li class="flex items-start gap-2">
                      <span class="mt-1">•</span>
                      <!-- Server-supplied activity description. -->
                      <span class="flex-1">{{ activity.levelDescription }}</span>
                      <div class="flex gap-1 flex-shrink-0">
                        <button
                          type="button"
                          class="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50 transition-colors"
                          (click)="openEditModal(
                            domain.domainName,
                            measure.measureName,
                            activity.levelDescription,
                            activity.levelSpanishDescription,
                            activity.activityBankId,
                            domain.iconName
                          )"
                          [attr.aria-label]="t('activityBank.editActivityAriaLabel')"
                        >
                          <mat-icon class="text-sm" [matTooltip]="t('activityBank.editActivity')">edit</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50 transition-colors mb-2"
                          (click)="openDeleteModal(
                            domain.domainName,
                            measure.measureName,
                            activity.levelDescription,
                            activity.activityBankId
                          )"
                          [attr.aria-label]="t('activityBank.deleteActivityAriaLabel')"
                        >
                          <i class="uil uil-trash-alt text-base"></i>
                        </button>
                      </div>
                    </li>
                    }
                  </ul>
                  } @else {
                  <div class="text-gray-400 italic">{{ t('activityBank.noActivities') }}</div>
                  }
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
      </drdp-container>
    </div>
    }
  </div>
</div>
</ng-container>
